"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const classnames_1 = require("classnames");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const assets_1 = require("../config/assets");
const config_1 = require("../config/config");
const TosCheckbox_1 = require("../field/TosCheckbox");
const RewardTermsModal = ({ visible, onClose, onRedeemButtonPress, rewardTerms, buttonStyle, classes, t, theme }) => {
    const [tosChecked, setTosChecked] = React.useState(false);
    const handleTosChecked = () => {
        setTosChecked(!tosChecked);
    };
    const openTos = () => {
        window.open(rewardTerms, '_blank');
    };
    return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(core_1.Dialog, Object.assign({ "aria-labelledby": "Redeem Reward Terms Modal", open: visible, keepMounted: true, onClose: onClose, "aria-describedby": `Reward Terms Modal`, className: 'po-widget-dialog' }, { children: [(0, jsx_runtime_1.jsxs)(core_1.DialogContent, Object.assign({ className: classes.modal }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", id: "modal-title", align: 'center', className: classes.modalTitle }, { children: t('reward.terms.title') })), (0, jsx_runtime_1.jsx)("img", { alt: 'reward free claim image', src: assets_1.assets.internalAssets.freeClaim, className: classes.modalImage }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body2", align: 'center', className: classes.modalInfo }, { children: t('reward.terms.info') })), rewardTerms && ((0, jsx_runtime_1.jsx)(TosCheckbox_1.default, { tosChecked: tosChecked, handleTosChecked: handleTosChecked, openTos: openTos, text2: t('reward.tos'), textColor: theme.palette.grey['900'], linkColor: theme.palette.secondary.dark }))] })), (0, jsx_runtime_1.jsxs)(core_1.DialogActions, Object.assign({ className: classes.modalActions }, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ color: config_1.config.internalConfig.BUTTON_BACKGROUND, size: 'large', variant: 'text', onClick: onClose, className: 'textButton' }, { children: t('reward.terms.cancel') })), (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ color: config_1.config.internalConfig.BUTTON_BACKGROUND, size: 'large', variant: 'contained', onClick: onRedeemButtonPress, disabled: !!rewardTerms && !tosChecked, className: (0, classnames_1.default)('containedButton', buttonStyle) }, { children: t('reward.terms.complete') }))] }))] })) }));
};
const styles = (theme) => (0, core_1.createStyles)({
    modal: {
        margin: theme.spacing(),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    modalTitle: {
        marginBottom: theme.spacing(4),
        color: theme.palette.common.black
    },
    modalInfo: {
        marginBottom: theme.spacing(2),
        color: theme.palette.common.black
    },
    modalTos: {
        color: theme.palette.common.black
    },
    modalImage: {
        width: 174,
        marginBottom: theme.spacing(2)
    },
    modalActions: {
        margin: theme.spacing(),
        marginBottom: theme.spacing(2)
    }
});
exports.default = (0, core_1.withTheme)((0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(RewardTermsModal)));
//# sourceMappingURL=RewardTermsModal.js.map